/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    projectGroup : null,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ProjectsetupAction.REQUEST_PROJECTSETUPDATA:
      return {
        ...state,
      };
    case actions.ProjectsetupAction.PROJECTSETUPDATA_RECEIVED:
      return{
        ...state,
        projectGroup : action.data.projectGroups,
      };    
    case actions.ProjectsetupAction.REQUEST_UPDATE_TASK_STATUS:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default reducer;
